/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the TranslationsApiConfiguration configuration object with a given root URL.
 */
export function provideTranslationsApiConfiguration(rootUrl: string) {
  var config = new TranslationsApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: TranslationsApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class TranslationsApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `O2TranslationsApiModule.forRoot()`
 */
export interface TranslationsApiConfigurationParams {
  rootUrl?: string;
}
